// extracted by mini-css-extract-plugin
export default {"renameProjectModal":"css_renameProjectModal__fPcA1","title":"css_title__XTL-7","field":"css_field__ALakz","error":"css_error__lnPJK","buttons":"css_buttons__Mq7wo"};